<template>
    <div style="margin-top:30px;">
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
                          
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="姓名" prop="boardName"  style="margin-right:15px">
                                <el-input v-model="form.boardName" placeholder=""  :disabled="isDisabled" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="电话" prop="boardPhone"  style="margin-right:15px">
                                <el-input v-model="form.boardPhone" placeholder=""  :disabled="isDisabled" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="邮件" prop="boardEmail"  style="margin-right:15px">
                                <el-input v-model="form.boardEmail" placeholder=""  :disabled="isDisabled" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="留言内容" prop="boardContent"  style="margin-right:15px">
                                <el-input v-model="form.boardContent" placeholder=""  :disabled="isDisabled" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="公司" prop="boardCompany"  style="margin-right:15px">
                                <el-input v-model="form.boardCompany" placeholder=""  :disabled="isDisabled" />
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
               
        </el-form>
        <div slot="footer" class="dialog-footer"  v-if="!isDisabled">
            <el-button @click="funcCancel">取 消</el-button>
            <el-button type="primary" @click="funcSubmit">确 定</el-button>
        </div>
    </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'messageBoardEdit',
        data() {
            return {
                isDisabled: false,
                submitMethod: 'post',
                emptyForm:{},
                form: {
                    code: '',
                    userCode: '',
                    branchCode: '',
                    boardName: '',
                    boardPhone: '',
                    boardEmail: '',
                    boardContent: '',
                    boardCompany: '',
                    readNumber: '',
                },
                rules: {
                    code: [
                        { required: true, message: '请输入', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    userCode: [
                        { required: true, message: '请输入用户编码code', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    branchCode: [
                        { required: true, message: '请输入组织机构编码', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 32 个字符', trigger: 'blur' }
                    ],
                    boardName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    boardPhone: [
                        { required: true, message: '请输入电话', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    boardEmail: [
                        { required: true, message: '请输入邮件', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
                    ],
                    boardContent: [
                        { required: true, message: '请输入留言内容', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 500 个字符', trigger: 'blur' }
                    ],
                    boardCompany: [
                        { required: true, message: '请输入公司', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 255 个字符', trigger: 'blur' }
                    ],
                    readNumber: [
                        { required: true, message: '请输入阅读次数', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {
            //保存空表单对象
            this.emptyForm =JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            init(isDisabled) {
                //查询到数据之前先展示空表单
                this.form = JSON.parse(JSON.stringify(this.emptyForm))
                this.isDisabled = isDisabled
                this.submitMethod = 'post' // 新增
            },
            // 获取页面信息
            getInfo(code) {
                this.submitMethod = 'put' // 编辑
                //查询到数据之前先展示空表单
                this.form=JSON.parse(JSON.stringify(this.emptyForm))
                request({ url: `/ntocc-basic-api/messageBoard/${code}`, method: 'get' }).then(response => {
                    this.form = response.data
                })
            },
            // 提交
            funcSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const data = this.form
                        request({ url: '/ntocc-basic-api/messageBoard', method: this.submitMethod, params: data }).then(response => {
                            this.$message({ message: response.msg, type: 'success' })
                            this.$emit('fatherEditMethod')
                        })
                    } else {
                        return false
                    }
                })
            },
            // 取消
            funcCancel() {
                this.$emit('fatherCancelMethod', 'edit')
            }

        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin:15px 0 15px 0;
        width: 175px;
        float: right;
    }
</style>
